import { useNavigate } from 'react-router';
import { useAuth } from '@/lib/auth-context';

export function useLogout() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  return () => {
    void logout();
    navigate('/', { replace: true });
  };
}
